import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './data-table.component';

import { SharedModule as IGShard } from '../../helper/shared.module';
import { CheckboxModule } from '@gridscale/primeng17/checkbox';
import { InputTextModule } from '@gridscale/primeng17/inputtext';
import { FormsModule } from '@angular/forms';

import { InternalTableModule } from './table/table.module';
import { LoaderModule } from '../loader/loader.module';
import { ButtonModule } from '../../elements/button/button.module';
import { EmptyStateModule } from '../../views/empty-state/empty-state.module';
import { CountLabelComponent } from '@gridscale/ingrid/elements/count-label';


@NgModule({
  declarations: [
    DataTableComponent
  ],
  imports: [
    CommonModule,
    InternalTableModule,
    FormsModule,
    ButtonModule,
    IGShard,
    InputTextModule,
    CheckboxModule,
    EmptyStateModule,
    LoaderModule,
    CountLabelComponent
  ],
  exports: [DataTableComponent]
})
export class DataTableModule { }
